import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullscreen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 6.25v-2.5a2 2 0 0 1 2-2h2.5m7.5 0h2.5a2 2 0 0 1 2 2v2.5m0 7.5v2.5a2 2 0 0 1-2 2h-2.5m-12-4.5v2.5a2 2 0 0 0 2 2h2.5"
	})]
});
const ForwardRef = forwardRef(SvgFullscreen);
export { ForwardRef as ReactComponent };
